import { Button, Progress, Skeleton } from "antd";
import API from "API";
import React, { useEffect, useState } from "react";
import { Scorm2004API } from "scorm-again";
import MessagePage from "../MessagePage";
import { CompressOutlined, ExpandOutlined, FrownOutlined } from "@ant-design/icons";
import { correct_media } from "general_function";
import toastr from "toastr";

export default function ScormPlayer({ scorm }) {
    const [starting, setStarting] = useState(true);
    const [scormProgress, setScormProgress] = useState(null);
    const [progress, setProgress] = useState(0);
    const [fullScreen, setFullScreen] = useState(false);
    useEffect(() => {
        setStarting(true);
        API.post('/student/create-scorm-progress', {
            scorm_id: scorm.id
        })
        .then(res => {
            setScormProgress(res.data);
            const progress = res.data.data["cmi.progress_measure"];
            if (progress) {
                setProgress(+progress*100);
            }
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {
            setStarting(false);
        })
    }, [scorm?.id])

    useEffect(() => {
        if (!scormProgress) return;
        var sending = false;
        window.API_1484_11 = new Scorm2004API({
            autocommit: true,
            log: true,
        });

        const scorm_data = {}

        window.API_1484_11.cmi.learner_id = scormProgress.student;
        window.API_1484_11.loadFromFlattenedJSON(scormProgress.data);

        window.API_1484_11.on("SetValue.cmi.* ", function (CMIElement, value) {
            if (CMIElement === "cmi.progress_measure") {
                setProgress(+value*100);
            }
            scorm_data[CMIElement] = value;  
        });

        const sendInterval = setInterval(() => {
            if (sending) return;
            if (Object.keys(scorm_data).length > 0) {
                sending = true;
                API.post("/student/update-scorm-progress", {
                    scorm_student_id: scormProgress.id,
                    scorm_data: scorm_data
                })
                .then(res => {})
                .catch(error => {
                    toastr.error("Không thể cập nhật tiến trình học!")
                })
                .finally(() => {
                    sending = false;
                })
            }
            for (const key in scorm_data) {
                delete scorm_data[key];
            }
        },2000)

        return () => {
            window.API_1484_11.clear("SetValue.cmi.*");
            window.API_1484_11 = undefined;
            clearInterval(sendInterval);
        };
    }, [scormProgress]);

    return starting ? <Skeleton active /> : (scormProgress === null ?
    <MessagePage
        icon={<FrownOutlined />}
        title="Thất bại trong quá trình lấy tiến trình học, bạn vui lòng tải lại trang!"
        extra={
            <Button type="primary" onClick={() => window.location.reload()}>
                Tải lại trang
            </Button>
        }
    />
    : <div style={fullScreen ? {
        position: "fixed",
        zIndex: 100000,
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "#fff",
    } : {}}>
        <div style={{ display: "flex", alignItems: "center"}}>
            <Progress percent={progress} />
            <Button style={{ marginLeft: 3 }} onClick={() => setFullScreen(!fullScreen)}>
                {!fullScreen ? <ExpandOutlined /> : <CompressOutlined />}
            </Button>
        </div>
        <iframe
            src={correct_media(`${scorm.folder}/index.html`)}
            title="Scorm"
            width="100%"
            height="800px"
            style={{ border: "none" }}
            sandbox="allow-scripts allow-forms allow-same-origin"
        />
        </div>)
}